

import './add-user.controller.js';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('inkfinder.artists.add', {
    url: '/add',
    abstract: true,
    views: {
      '@': {
        template: require('./template.base.html'),
        controller: 'AddUserController as AddUserController'
      }
    },

    // Set the starting route of the add artist process
    data: {
      startingRoute: ['inkfinder.artists.add.search']
    }
  })

  // Add an artist: Collector search
  .state('inkfinder.artists.add.search', {
    url: '/search',
    template: require('./collector-search-add.html'),
    resolve: {
      $title: function() {
        return 'Invite an artist';
      }
    }
  })

  // Add an artist: Select a collector
  .state('inkfinder.artists.add.collector-select', {
    url: '/select',
    template: require('./collector-select.html'),
    resolve: {
      $title: function() {
        return 'Search results';
      }
    }
  })

  // Add an artist: Add a collector
  .state('inkfinder.artists.add.collector-create', {
    url: '/invite',
    template: require('./collector-create.html'),
    resolve: {
      $title: function() {
        return 'Create an account';
      }
    }
  })

  // Add an artist: Add the association
  .state('inkfinder.artists.add.association', {
    url: '/association',
    template: require('./artist-association.html'),
    resolve: {
      $title: function() {
        return 'Set start and end dates';
      }
    }
  })

  // Add an artist: Invite complete
  .state('inkfinder.artists.add.complete', {
    url: '/complete',
    template: require('./artist-add-complete.html'),
    resolve: {
      $title: function() {
        return 'Artist invite complete';
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/artists/add/index.js